import { useEffect, useState } from "react";
import { AccordionComponent } from "../../modules/StoresModule/Components/Accordion/AccordionComponent";
import "./Filters.css";
import { AccordionDetails, Checkbox, FormControlLabel } from "@mui/material";
import { Dropdowns } from "../Dropdowns/Dropdowns";
import Input from "../Inputs/Input";
import { dropdownConfig } from "../../services/dropdownsConfigService";

const Filters = ({
  x,
  openChange,
  onApplyFilters,
  hideToggle,
  extOpen,
  dropdownIds,
  hideATA,
}) => {
  const [showResults, setShowResults] = useState(false);
  const [closeAccordionWithSearch, setCloseAccordionWithSearch] =
    useState(false);
  const [basicFilters, setBasicFilters] = useState([]);
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(-1); // Inicia en 0 (primer dropdown);
  const [txtFilters, setTxtFilters] = useState({});

  const dropdownsConfigId = [1, 2, 3, 11, 12, 13, 87, 102, 88, 126];
  const nonAtaDropdowns = dropdownIds ?? [1, 2, 3, 87, 102, 88, 126];
  const AtaDropdowns = [11, 12, 13];

  const [fitlersToApply, setFiltersToApply] = useState({});

  useEffect(() => {
    openChange?.(showResults);
  }, [showResults]);

  useEffect(() => {
    setCloseAccordionWithSearch(extOpen);
  }, [extOpen]);

  const txtChange = (e) => {
    let { name, value } = e.target;
    setTxtFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleTabNavigation = (event) => {
    // if (event.key === "Tab") {
    //   event.preventDefault();
    //   setActiveDropdownIndex((prevIndex) => {
    //     const nextIndex = (prevIndex + 1) % basicFilters.length; // Ciclo infinito
    //     return nextIndex;
    //   });
    // }
  };

  const getDropdownsConfig = async () => {
    try {
      const responses = await Promise.all(
        dropdownsConfigId.map(async (e) => {
          const req = await dropdownConfig(e);
          if (req.data.responseCode === 200) {
            return req.data.load;
          }

          return null;
        })
      );

      const validData = responses.filter((data) => data !== null);

      basicFilters.length <= 0
        ? setBasicFilters((prevData) => [...prevData, ...validData])
        : null;
    } catch (error) {
      console.error("Error fetching dropdown configs:", error);
    }
  };

  const handleCloseAccordion = () => {
    onApplyFilters?.(fitlersToApply, txtFilters);
    setCloseAccordionWithSearch((prevState) => !prevState);
    setShowResults(!showResults);
  };

  const simpleDropdownApply = () => {
    onApplyFilters?.(fitlersToApply, txtFilters);
    setShowResults((prev) => (prev ? !prev : prev));
  };

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setBasicFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };

  const resetDropdownsReload = () => {
    setBasicFilters((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const selectOption = (values, filter) => {
    setFiltersToApply((prev) => ({ ...prev, [filter.id]: values }));
  };

  useEffect(() => {}, [fitlersToApply]);

  useEffect(() => {
    window.addEventListener("keydown", handleTabNavigation);
    return () => {
      window.removeEventListener("keydown", handleTabNavigation);
    };
  }, [basicFilters.length]);

  useEffect(() => {
    try {
      getDropdownsConfig();
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <>
      <div className="filters-component">
        <AccordionComponent
          title="Filters"
          changeOpen={closeAccordionWithSearch}
          hideToggle={hideToggle}
        >
          <AccordionDetails sx={{ padding: "0" }}>
            <div className="filter-all-cont">
              {/* basic filters section */}

              <section className="basicFilters-cont">
                {!hideATA && <h2>Basic Filters</h2>}
                <div className="inputs-basicFilters-cont">
                  {basicFilters.length <= 0 ? (
                    <p className="loading-dropdowns">Loading Dropdowns...</p>
                  ) : (
                    basicFilters.map((filter, index) => {
                      // renderizado de los dropdowns
                      return (
                        nonAtaDropdowns.includes(filter.id) && (
                          <Dropdowns
                            key={index}
                            data={filter}
                            currentIndexTab={activeDropdownIndex === index}
                            updateDropdown={updateDropdown}
                            resetDropdownsReload={resetDropdownsReload}
                            onAllOptionsSelected={(values) =>
                              selectOption(values, filter)
                            }
                            onApplySelection={simpleDropdownApply}
                          ></Dropdowns>
                        )
                      );
                    })
                  )}
                </div>
                {!hideATA && (
                  <section className="advance-filters-sect2">
                    <h2>ATA</h2>
                    <section>
                      {basicFilters?.map((filter, index) => {
                        // renderizado de los dropdowns
                        return (
                          AtaDropdowns.includes(filter.id) && (
                            <Dropdowns
                              // selectionLabel={selectionLabels[filter.id]}
                              optionLabel="description"
                              key={index}
                              data={filter}
                              currentIndexTab={activeDropdownIndex === index}
                              updateDropdown={updateDropdown}
                              resetDropdownsReload={resetDropdownsReload}
                              onAllOptionsSelected={(values) =>
                                selectOption(values, filter)
                              }
                              onApplySelection={simpleDropdownApply}
                            ></Dropdowns>
                          )
                        );
                      })}
                      {/* <input type="text" placeholder="Chapter" />
                  <input type="text" placeholder="Section" />
                  <input type="text" placeholder="Paragraph" /> */}
                    </section>
                  </section>
                )}
              </section>
              {/* advanced filters section */}
              {/* <section className="advancedFilters-cont">
                  <AccordionComponent
                    arrowPosition="left"
                    title={
                      <p className="title-advanced-filters">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="27.5"
                          height="26"
                          viewBox="0 0 27.5 26"
                        >
                          <g
                            id="Grupo_1128"
                            data-name="Grupo 1128"
                            transform="translate(1 2)"
                          >
                            <line
                              id="Línea_84"
                              data-name="Línea 84"
                              x1="23"
                              transform="translate(0 11)"
                              fill="none"
                              stroke="#000"
                              strokeLinecap="round"
                              strokeWidth="2"
                            />
                            <line
                              id="Línea_85"
                              data-name="Línea 85"
                              x1="23"
                              transform="translate(0 20)"
                              fill="none"
                              stroke="#000"
                              strokeLinecap="round"
                              strokeWidth="2"
                            />
                            <line
                              id="Línea_86"
                              data-name="Línea 86"
                              x1="23"
                              transform="translate(0 2)"
                              fill="none"
                              stroke="#000"
                              strokeLinecap="round"
                              strokeWidth="2"
                            />
                            <g
                              id="Elipse_192"
                              data-name="Elipse 192"
                              transform="translate(3.5 9)"
                              fill="#fff"
                              stroke="#000"
                              strokeWidth="2"
                            >
                              <circle cx="2" cy="2" r="2" stroke="none" />
                              <circle cx="2" cy="2" r="3" fill="none" />
                            </g>
                            <g
                              id="Elipse_193"
                              data-name="Elipse 193"
                              transform="translate(20.5 18)"
                              fill="#fff"
                              stroke="#000"
                              strokeWidth="2"
                            >
                              <circle cx="2" cy="2" r="2" stroke="none" />
                              <circle cx="2" cy="2" r="3" fill="none" />
                            </g>
                            <g
                              id="Elipse_194"
                              data-name="Elipse 194"
                              transform="translate(20.5)"
                              fill="#fff"
                              stroke="#000"
                              strokeWidth="2"
                            >
                              <circle cx="2" cy="2" r="2" stroke="none" />
                              <circle cx="2" cy="2" r="3" fill="none" />
                            </g>
                          </g>
                        </svg>
                        Advanced Filters
                      </p>
                    }
                  >
                    <AccordionDetails sx={{ padding: "0" }}>
                      <section className="advanced-filters-inpsCont">
                        <section className="advance-filters-sect1">
                          <div>
                            <input
                              type="text"
                              placeholder="Goods Received Number (GRN)"
                            />
                          </div>
                          <div>
                            <input type="text" placeholder="Lot Number" />
                          </div>

                          <div>
                            <input type="text" placeholder="Shelf life date" />
                          </div>
                          <div>
                            <input type="text" placeholder="Tool life date" />
                          </div>
                          <div>
                            <input type="text" placeholder="Owner (PN)" />
                          </div>
                        </section>

                        <section className="advance-filters-sect2">
                          <h2>ATA</h2>
                          <section>
                            <input type="text" placeholder="Chapter" />
                            <input type="text" placeholder="Section" />
                            <input type="text" placeholder="Paragraph" />
                          </section>
                        </section>
                        <section className="advance-filters-sect3">
                          <input type="text" placeholder="Legacy Batch" />
                          <div
                            onClick={(e) => handleSelectionInterchangeable(e)}
                            style={{
                              background: checkedInterchangeable
                                ? "#DBFFEE"
                                : "",
                            }}
                          >
                            <FormControlLabel
                              sx={{
                                color: "#fff",
                                ".css-1y5vrnu-MuiButtonBase-root-MuiCheckbox-root.Mui-checked, .css-1y5vrnu-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate":
                                  {
                                    color: "#50D999",
                                  },
                              }}
                              control={<Checkbox />}
                              label={
                                <p
                                  className="txt-black-mid"
                                  style={{
                                    fontSize: "calc(var(--p-size) - .1rem)",
                                  }}
                                >
                                  Include Interchangeable parts
                                </p>
                              }
                            ></FormControlLabel>
                          </div>
                        </section>
                      </section>
                    </AccordionDetails>
                  </AccordionComponent>
                </section> */}
              <button
                className="btn-search-inventory-management"
                onClick={handleCloseAccordion}
              >
                <svg
                  id="Group_968"
                  data-name="Group 968"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 18.998 18.999"
                >
                  <g id="Group_809" data-name="Group 809">
                    <path
                      id="Path_642"
                      data-name="Path 642"
                      d="M1337.771,45.422A6.475,6.475,0,1,1,1331.3,51.9a6.482,6.482,0,0,1,6.474-6.475m0-1.5a7.975,7.975,0,1,0,7.975,7.975,7.975,7.975,0,0,0-7.975-7.975Z"
                      transform="translate(-1329.797 -43.922)"
                      fill="#fff"
                    />
                    <path
                      id="Línea_80"
                      data-name="Línea 80"
                      d="M4.6,5.347a.748.748,0,0,1-.53-.22L-.53.53A.75.75,0,0,1-.53-.53.75.75,0,0,1,.53-.53l4.6,4.6a.75.75,0,0,1-.53,1.28Z"
                      transform="translate(13.651 13.652)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                Search
              </button>
            </div>
          </AccordionDetails>
        </AccordionComponent>
        {/* <div className="filters-header">
        <b>Filters</b>
        <i className='icon-arrow-down'></i>
      </div> */}
      </div>
      <hr />
    </>
  );
};

export default Filters;
